"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BinaryOperation = void 0;
const Expression_1 = require("./Expression");
/**
 * Represents a binary operation on two expressions.
 *
 * @template T The input type of the expression.
 * @template R The output type of the expressions.
 * @param {Expression<T, R>} left The left expression.
 * @param {Expression<T, R>} right The right expression.
 * @param {(a: R, b: R) => number} operator The operator function that takes two values of type R and returns a number.
 */
class BinaryOperation extends Expression_1.Expression {
    constructor(left, right, operator) {
        super();
        this.left = left;
        this.right = right;
        this.operator = operator;
    }
    /**
     * Executes the binary operation on the given object.
     *
     * @param {T} obj The object on which the operation will be executed.
     * @returns {number} The result of the binary operation.
     */
    execute(obj) {
        return this.operator(this.left.execute(obj), this.right.execute(obj));
    }
}
exports.BinaryOperation = BinaryOperation;
